import { render, staticRenderFns } from "./NavSecondary.vue?vue&type=template&id=b24b3462"
import script from "./NavSecondary.vue?vue&type=script&lang=js"
export * from "./NavSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports